import React from 'react';
import Navbar from './Navbar';
import OfflineIndicator from './OfflineIndicator';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen with-navbar">
      <Navbar 
        onMenuClick={() => console.log('Menu clicked')}
      />
      <OfflineIndicator />
      <div>
        {children}
      </div>
    </div>
  );
};

export default Layout;